// Import standards
import { useEffect, useState } from "react";
import axios from "../config/api";
import { HashLink } from "react-router-hash-link";

// Components
import CountryCard from "../components/CountryCard";
import PlaceholderCard from "../components/PlaceholderCard";

// Bulma Components
import {
  Heading,
  Container,
  Columns,
  Level,
  Tag,
  Menu
} from "react-bulma-components";

// Region Page to display Countries categorised into each region
const Region = () => {
  const [countries, setCountries] = useState([]);

  // Async for fetching for REST Countries API and assign to countries variable
  useEffect(() => {
    axios
      .get(
        `/all?=fields=name,flags,coatOfArms,subregion,capital,population,region`
      )
      .then((response) => {
        let data = response.data;
        setCountries(data);
      })
      .catch((error) => console.error(error));
  }, []);

  // display nothing when countries has not return its data
  if (!countries.length) return "";

  // Template cards used as placeholders before the data loaded
  let TemplateCards = [];
  for (let i = 0; i < 15; i++) {
    TemplateCards.push(<PlaceholderCard key={`templateCard${i}`} />);
  }

  // Side menu for Region Page 
  const SideMenu = () => {
    
    // smooth scroll to element invoked
    // when a menu item is clicked
    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -80; 
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });

    }
    
    return (
        <Menu ml={5} pt={5} style={{ position: "fixed", top: "10px", bottom: "0", width: "240px", overflowY: "scroll", overflowX: "hidden" }} mt={6}>
            <Menu.List title="Region">
            {/* Side for African Subregions */}
            <Menu.List.Item className="menuItem" renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Africa">
                <Menu.List title="Africa">
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#NorthernAfrica">Northern Africa</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#EasternAfrica">Eastern Africa</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#MiddleAfrica">Middle Africa</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#WesternAfrica">Western Africa</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#SouthernAfrica">Southern Africa</Menu.List.Item>
                    </Menu.List>
                </Menu.List.Item>
                {/* Side for American Subregions */}
                <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#America">
                    <Menu.List title="America">
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#NorthAmerica">North America</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#CentralAmerica">Central America</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#SouthAmerica">South America</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Caribbean">Caribbean</Menu.List.Item>
                    </Menu.List>
                </Menu.List.Item>
                {/* Side for Asian Subregions */}
                <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Asia">
                <Menu.List title="Asia">
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#EasternAsia">Eastern Asia</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#CentralAsia">Central Asia</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#WesternAsia">Western Asia</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#SouthernAsia">Southern Asia</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#South-EasternAsia">South-Eastern Asia</Menu.List.Item>
                    </Menu.List>
                </Menu.List.Item>
                {/* Side for European Subregions */}
                <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Europe">
                    <Menu.List title="Europe">
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#NorthernEurope">Northern Europe</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#CentralEurope">Central Europe</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#WesternEurope">Western Europe</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#SouthernEurope">Southern Europe</Menu.List.Item>
                    </Menu.List>
                </Menu.List.Item>
                {/* Side for Oceanian Subregions */}
                <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Oceania">
                    <Menu.List title="Oceania">
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Australiaand New Zealand">Australia and New Zealand</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Melanesia">Melanesia</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Micronesia">Micronesia</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Polynesia">Polynesia</Menu.List.Item>
                    </Menu.List>
                </Menu.List.Item>
            </Menu.List>
        </Menu>
    )
  };

  // Subregion component to reduces hard coding
  const SubregionSection = (props) => {
    const [subregion, setSubregion] = useState([]);

    useEffect(() => {
      // Set subregion by filtering the each country region 
      setSubregion(
        countries.filter((country) => country.subregion === props.subregion)
      );
    }, [props.subregion]);

    // Create a new array out of the filter
    const SubregionCards = subregion.map((country, i) => {
      return (
        <CountryCard
          display="flex"
          size="4"
          key={`${props.subregion}Card${i}`}
          flags={country.flags.png}
          coatOfArms={country.coatOfArms.png}
          name={country.name.common}
          region={country.subregion}
          capital={country.capital}
          population={country.population}
        />
      );
    });

    // Remove spaces between the subregion name
    // This will be inserted as ID for scrolling into the element
    const removeTextSpace = props.subregion.replace(" ", "");

    return (
      <>
        <Columns.Column size={12}>
          <Tag.Group
            renderAs={HashLink}
            smooth
            to={`#${removeTextSpace}`}
            id={`${removeTextSpace}`}
            hasAddons
          >
            <Tag rounded color="warning" size="large">
              # {props.subregion}
            </Tag>
            <Tag rounded color="text" size="large">
              {SubregionCards.length} countries
            </Tag>
          </Tag.Group>
        </Columns.Column>
        {subregion.length ? SubregionCards : TemplateCards}
        <Columns.Column size={12}>
          <hr className="has-background-white-ter" />
        </Columns.Column>
      </>
    );
  };

  return (
    <>
      <div className="has-background-white-bis">

        {/* Side menu to ease user in traversing the page */}
        <SideMenu />

        {/* Container for subregions */}
        <Container breakpoint="desktop" max="desktop" pt={6}>
          <Columns mt="auto">
            {/* African Regions */}
            <Columns.Column size={12} mt="auto">
              <Level id="Africa">
                <Level.Item renderAs={Columns.Column} align="left">
                  <Heading textSize={3} textWeight="bold">
                    <span className="is-size-2 has-text-grey-lighter">#</span>{" "}
                    Africa
                  </Heading>
                </Level.Item>
              </Level>
            </Columns.Column>

            {/* Display countries into their subregion */}
            <SubregionSection subregion="Northern Africa"/>
            <SubregionSection subregion="Eastern Africa"/>
            <SubregionSection subregion="Middle Africa"/>
            <SubregionSection subregion="Western Africa"/>
            <SubregionSection subregion="Southern Africa"/>

            {/* American Regions */}
            <Columns.Column size={12} mt="auto">
              <Level id="America">
                <Level.Item renderAs={Columns.Column} align="left">
                  <Heading textSize={3} textWeight="bold">
                    <span className="is-size-2 has-text-grey-lighter">#</span>{" "}
                    America
                  </Heading>
                </Level.Item>
              </Level>
            </Columns.Column>

            {/* Display countries into their subregion */}
            <SubregionSection subregion="North America"/>

            <SubregionSection subregion="Central America"/>

            <SubregionSection subregion="South America"/>

            <SubregionSection subregion="Caribbean"/>

            {/* Asian Regions */}
            <Columns.Column size={12} mt="auto">
              <Level id="Asia">
                <Level.Item renderAs={Columns.Column} align="left">
                  <Heading textSize={3} textWeight="bold">
                    <span className="is-size-2 has-text-grey-lighter">#</span>{" "}
                    Asia{" "}
                  </Heading>
                </Level.Item>
              </Level>
            </Columns.Column>

            {/* Display countries into their subregion */}
            <SubregionSection subregion="Eastern Asia"/>

            <SubregionSection subregion="Central Asia"/>

            <SubregionSection subregion="Western Asia"/>

            <SubregionSection subregion="Southern Asia"/>

            <SubregionSection subregion="South-Eastern Asia"/>

            {/* European Regions */}
            <Columns.Column paddingless size={12} mt="auto">
              <Level id="Europe">
                <Level.Item renderAs={Columns.Column} align="left">
                  <Heading textSize={3} textWeight="bold">
                    <span className="pt-3 is-size-2 has-text-grey-lighter">
                      #
                    </span>{" "}
                    Europe
                  </Heading>
                </Level.Item>
                <Level.Item
                  renderAs={Columns.Column}
                  align="right"
                ></Level.Item>
              </Level>
              <hr />
            </Columns.Column>

            {/* Display countries into their subregion */}
            <SubregionSection subregion="Northern Europe"/>

            <SubregionSection subregion="Central Europe"/>

            <SubregionSection subregion="Western Europe"/>

            <SubregionSection subregion="Southern Europe"/>

            {/* Oceania Regions */}
            <Columns.Column paddingless size={12} mt="auto">
              <Level id="Oceania">
                <Level.Item renderAs={Columns.Column} align="left">
                  <Heading textSize={3} textWeight="bold">
                    <span className="pt-3 is-size-2 has-text-grey-lighter">
                      #
                    </span>{" "}
                    Oceania
                  </Heading>
                </Level.Item>
                <Level.Item
                  renderAs={Columns.Column}
                  align="right"
                ></Level.Item>
              </Level>
              <hr />
            </Columns.Column>

            {/* Display countries into their subregion */}
            <SubregionSection
              subregion="Australia and New Zealand"
              data={countries}
            />
            <SubregionSection subregion="Melanesia"/>
            <SubregionSection subregion="Micronesia"/>
            <SubregionSection subregion="Polynesia"/>

          </Columns>
        </Container>
      </div>
    </>
  );
};

export default Region;
